import * as React from 'react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';

interface ProductSupplementsViewProps extends ComponentViewProps<DataSet<ProductItem>> {
    mode: ControlMode;
    onItemDoubleClicked?: (item: ProductItem) => any;
}

export class ProductSupplementsView extends React.Component<ProductSupplementsViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        const dataService = this.props.model;
        const columns = [
            {
                key: 'displayName',
                title: 'Name',
                dataIndex: 'displayName',
                render: (text, record, index) => {
                    return record.dynamicProperties.displayName.en;
                }
            }
        ];
        return (
            <DataTableView
                mode={this.props.mode}
                createNewItem={() => this.props.onItemDoubleClicked(null)}
                setBusy={this.props.setBusy}
                columns={columns}
                model={dataService}
                hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
                itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-supplements.view.tsx